import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import { AssistanceSection, BenefitSection, BoostSection, CustomSection, FAQ, LargeData, ServicesSection, roleWriting } from '../../Data/All_Services_Data/laravelDevelopmentData';
import Custom_section from '../../component/Services_Component/Custom_services_section';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const LaravelDevelopment = () => {
    useMetaTags({
      title:
        "Top Laravel Development Services Company for Custom Web Solutions",
      description:
        "As a top Laravel development services Company, we build tailored web applications that are scalable, secure, and optimized for your business objectives and growth.",
      keywords:
        "laravel development services, laravel development Company, laravel development agency, laravel web development, laravel software development, laravel website development services, laravel web development company, laravel website development, laravel app development, laravel website development company, laravel web development services, laravel development",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h1 className="sec-title text-white">
                  Custom Laravel Development Services
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        .extra-box{
          display: flex;
          height: 70px;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 25px;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/laraveldeveloper.png"
                  loading="lazy"
                  alt="heading_image"
                />
                <div>
                  <p>
                    At Warrgyizmorsch we provide best in class Laravel
                    development services which we use to transform businesses’
                    digital presence with powerful and custom made web
                    solutions. Laravel which is known for its elegant code
                    structure, scalability and performance is the framework we
                    choose for developing robust applications that fit your
                    unique goals. Whether you’re a start-up looking to go to
                    market quickly or an established player looking to modernize
                    legacy systems, our team which brings together technical
                    skill and strategic insight is what makes us tick.
                  </p>
                </div>
              </div>
              <Handle_Largedata_section LargeData={LargeData} />
              <Custom_section data={CustomSection} />
              <Role_writing data={roleWriting} />
              <Boost_section data={BoostSection} />
              <div className="extra-box"></div>
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default LaravelDevelopment;